import React, { useContext, useEffect, useState } from 'react'

// import { useUploadHeader } from '../../hooks/UploadHeaderConfiguration/useUploadHeader'

import { useHistory } from 'react-router'
import CustomTableLayout from '../../../components/CustomComponents/CustomTableLayout'
import UploadHeaderDialog from '../../../components/Dialog/UploadHeadersDialog'
import { ConfigurationContext } from '../../../context api/Configuration/ConfigurationContext'
import { useUploadHeader } from '../../../hooks/CompanyConfiguration/useUploadHeader'
import { useDownload } from '../../../hooks/Download/useDownload'
import { formatDate, ROUTES } from '../../../shared/constants'

export default function UploadHeaders() {
  const { getAllUploadHeader, deleteManyUploadHeader, loading, paginate, updateUploadHeader } = useUploadHeader()
  const { downloadLoading, getPdfCsvData, pdfCsvData } = useDownload()
  const [headers, setHeaders] = useState(false)
  const { uploadHeaders } = useContext(ConfigurationContext)
  console.log('uploadHeaders : ', uploadHeaders)
  const history = useHistory()

  const [searchQuery, setSearchQuery] = useState('')
  const filterUploadHeader = uploadHeaders
  const [page, setPage] = React.useState(1)

  const noOfPages = paginate && paginate.totalPage
  useEffect(() => {
    getAllUploadHeader({
      page: page,
      limit: 10,
      searchQuery,
    })
  }, [page, searchQuery])

  useEffect(() => {
    // getPdfCsvData('GET_ALL_UPLOAD_HEADERS')
  }, [])

  const handleChange = (event, value) => {
    setPage(value)
  }

  const handleSwitchChange = (item) => updateUploadHeader({ ...item, active: !item.active, uploadHeaderId: item._id })

  let tableBody = []

  if (!loading && filterUploadHeader.length > 0) {
    tableBody = filterUploadHeader.map((item) => {
      return [
        { type: 'CHECKBOX', _id: item._id },
        { value: item.uploadHeaderCode },
        { value: item.name },
        { value: 'View', style: { color: 'blue', textDecoration: 'underline', cursor: 'pointer' }, onClick: () => setHeaders(item.headers) },
        { value: formatDate(item.createdAt) },
        { type: 'STATUS', ...item },
        { type: 'INFO', onClick: () => history.push(`/view-upload-header/${item._id}`) },
      ]
    })
  }

  const layoutProps = {
    heading: 'Manage UploadHeaders',
    url: ROUTES.ADD_UPLOAD_HEADER,
    editUrl: `/edit-upload-header/`,
    searchQuery: searchQuery,
    setSearchQuery: setSearchQuery,
    tempHeaderData: [],
    filename: 'uploadHeaders',
    headers: pdfCsvData.headings,
    data: pdfCsvData.headingValues,
    downloadLoading,
  }

  return (
    <>
      <UploadHeaderDialog open={headers} handleClose={() => setHeaders(false)} data={headers} />
      <CustomTableLayout
        tableHeadings={['UploadHeader Code', 'Name', 'Headers', 'Created Date', 'Status', 'Info']}
        loading={loading}
        tableBody={tableBody}
        handleSwitchChange={handleSwitchChange}
        handlePageChange={handleChange}
        paginate={{ totalPage: noOfPages, page: page }}
        layoutProps={layoutProps}
        checkbox
        deleteMany={(val, setSelected) => deleteManyUploadHeader({ uploadHeaderId: val }, setSelected)}
      />
    </>
  )
}
